import { useState } from "react";
import downloadReceipt from "utils/helpers/downloadReceipt";

/** Same helper the old BookingActions used. Shared by the payment card and the invoice drawer. */
export const useReceiptDownload = (booking: any) => {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState("");
  const canDownload = !!booking?.id && !!booking?.number;

  const download = async () => {
    if (!canDownload) return;
    setDownloading(true);
    setError("");
    try {
      await downloadReceipt(Number(booking.id), booking.number);
    } catch (e) {
      console.error("Receipt download failed:", e);
      setError("We couldn't generate the receipt. Please try again.");
    } finally {
      setDownloading(false);
    }
  };

  return { download, downloading, error, canDownload };
};
